import React, { Button, Component, useState } from "react";

// components
import Cookies from "universal-cookie";
import getLezioni from "../../services/getLezioni";
import getCorso from "../../services/getCorso";
import getChiusura from "../../services/getChiusura";
import getInsegnanti from "../../services/getInsegnanti";
import Utils from "../../utils/utils";
import moment from "moment";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import getCorsi from "../../services/getCorsi";

import NeroTrasparente from "../../images/loghi/nero_trasparente.png";
import getPianoPagamentiCorso from "../../services/getPianoPagamentiCorso";

export default class PdfCalendarioCorsoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nomeCorso: "",
    };
  }

  removeDuplicates(array) {
    const ids = new Set();
    return array.filter((item) => {
      if (ids.has(item.id)) {
        return false;
      }
      ids.add(item.id);
      return true;
    });
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCorso = cookies.get("currentCourse", { path: "/" });

    this.lezioni = await getLezioni(username, token);
    this.chiusura = await getChiusura(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.corsi = await getCorsi(username, token);
    this.pagamentiCorso = await getPianoPagamentiCorso(
      username,
      token,
      currentCorso
    );
    console.log("this.pagamentiCorso", this.pagamentiCorso);

    if (!currentCorso.includes(";")) {
      this.corso = await getCorso(username, token, currentCorso);

      this.lezioni = this.lezioni.filter(
        (l) =>
          l.id_corso == currentCorso ||
          l.altri_corsi.split(";").indexOf(currentCorso) != -1
      );
    } else {
      let finalLezioni = [];
      let name = cookies.get("pdfUnione", { path: "/" });
      this.corso = { name };

      finalLezioni = this.removeDuplicates(finalLezioni);
      this.lezioni = [...finalLezioni];
    }

    this.lezioni.forEach((l, i) => {
      let altriInsegnanti = "";
      let arrInsegnanti = l.id_insegnanti ? l.id_insegnanti.split(",") : [];

      arrInsegnanti.forEach((temp) => {
        if (!temp) return;
        let tempInsegnante = this.insegnanti.find(
          (insegnante) => insegnante.id == temp
        );
        if (tempInsegnante) {
          altriInsegnanti +=
            (altriInsegnanti ? ", " : "") +
            tempInsegnante.nome +
            " " +
            tempInsegnante.cognome;
        }
      });

      let altriCorsi = "";
      let arrAltriCorsi = l.altri_corsi ? l.altri_corsi.split(";") : [];
      arrAltriCorsi.forEach((t) => {
        if (!t) return;
        let tempCorso = this.corsi.find((corso) => corso.id == t);
        if (tempCorso) {
          altriCorsi += (altriCorsi ? ", " : "") + tempCorso.name;
        }
      });

      if (!currentCorso.includes(";") && this.corso && this.corso.name) {
        altriCorsi = altriCorsi
          .replace(new RegExp(`,?\\s*${this.corso.name}`, "g"), "")
          .trim();
      }

      this.lezioni[i].altriInsegnanti = altriInsegnanti;
      this.lezioni[i].altriCorsi = altriCorsi;
    });

    this.lezioni = this.lezioni.sort((l1, l2) => {
      let ll1 = moment(l1.data, "YYYY-MM-DD HH:mm:ss");
      let ll2 = moment(l2.data, "YYYY-MM-DD HH:mm:ss");
      return ll1 - ll2;
    });

    this.mesi = [];
    this.coppieMesi = [];
    let tempMese = "";

    this.lezioni.forEach((l) => {
      let ll = moment(l.data, "YYYY-MM-DD HH:mm:ss");
      let mmYYYY = ll.format("YYYY-MM");
      if (!this.mesi.includes(mmYYYY)) {
        this.mesi.push(mmYYYY);
        if (tempMese) {
          this.coppieMesi.push([tempMese, mmYYYY]);
          tempMese = "";
        } else {
          tempMese = mmYYYY;
        }
      }
    });

    let lezioniConPagamento = this.lezioni.map((lezione) => {
      const pagamentoPerData = this.pagamentiCorso?.rate?.find((rate) => {
        const lezioneData = lezione.data
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("-");
        return lezioneData === rate.data;
      });

      if (pagamentoPerData) {
        return { ...lezione, pagamento: true };
      }

      return lezione;
    });

    const lezioniDate = this.lezioni.map((lezione) =>
      lezione.data
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("-")
    );

    const pagamentiMancanti =
      this.pagamentiCorso?.rate
        ?.filter((rate) => !lezioniDate.includes(rate.data))
        ?.map((rate, index) => {
          const [day, month, year] = rate.data.split("-");
          const dataFormattata = `${year}-${month.padStart(
            2,
            "0"
          )}-${day.padStart(2, "0")} 00:00:00`;

          return {
            id: `pagamento-${index + 1}`,
            data: dataFormattata,
            pagamento: true,
            str_corso: this.corso?.name || "",
            durata: 0,
          };
        }) || [];

    lezioniConPagamento = [...lezioniConPagamento, ...pagamentiMancanti];

    this.lezioniConPagamento = lezioniConPagamento;

    if (tempMese) {
      this.coppieMesi.push([tempMese]);
    }

    this.setState({});
  }

  render() {
    console.log("lezioniConPagamento", this.lezioniConPagamento);

    const calcolaDurata = (dataInizio, durataMinuti) => {
      const inizio = new Date(dataInizio);
      const fine = new Date(inizio.getTime() + durataMinuti * 60000);

      const formatTime = (date) => {
        return `${date.getHours()}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;
      };

      return `${formatTime(inizio)} - ${formatTime(fine)}`;
    };

    return (
      <div style={{ width: "100%", height: "100%" }} key={Math.random()}>
        {!this.lezioni || this.lezioni.length === 0 ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h3 style={{ margin: "auto" }}>Nessuna lezione presente</h3>
          </div>
        ) : (
          <PDFViewer style={{ width: "100%", height: "100%" }}>
            <Document>
              <Page size="A4" style={styles.page} orientation="portrait">
                <Text
                  style={{
                    marginVertical: 5,
                    fontSize: 24,
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {this.lezioni && this.lezioni[0].str_corso}
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    width: "100%",
                    textAlign: "center",
                    marginTop: 3,
                  }}
                >
                  Calendario delle lezioni e delle scadenze dei pagamenti
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    width: "100%",
                    textAlign: "center",
                    marginTop: 3,
                    marginBottom: 5,
                  }}
                >
                  Orario:{" "}
                  {moment(this.lezioni[0].data, "YYYY-MM-DD HH:mm:ss").format(
                    "dddd"
                  )}{" "}
                  {calcolaDurata(this.lezioni[0].data, this.lezioni[0].durata)}
                </Text>
                <View style={styles.tableWrapper}>
                  <View style={styles.table}>
                    {/* Header della tabella */}
                    <View style={styles.tableRow}>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 45 },
                        ]}
                      >
                        <Text style={styles.headerText}>Anno</Text>
                      </View>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 75 },
                        ]}
                      >
                        <Text style={styles.headerText}>Mese</Text>
                      </View>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 89 },
                        ]}
                      >
                        <Text style={styles.headerText}>GG</Text>
                      </View>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 89 },
                        ]}
                      >
                        <Text style={styles.headerText}>GG</Text>
                      </View>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 89 },
                        ]}
                      >
                        <Text style={styles.headerText}>GG</Text>
                      </View>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 89 },
                        ]}
                      >
                        <Text style={styles.headerText}>GG</Text>
                      </View>
                      <View
                        style={[
                          styles.tableCell,
                          styles.headerCell,
                          { width: 89 },
                        ]}
                      >
                        <Text style={styles.headerText}>GG</Text>
                      </View>
                    </View>

                    {/* Righe della tabella */}
                    {this.lezioniConPagamento &&
                      (() => {
                        const gruppiMese = Object.values(
                          this.lezioniConPagamento
                            .filter((lezione) => {
                              // Filtra solo le lezioni con date valide
                              const dataMoment = moment(
                                lezione.data,
                                "YYYY-MM-DD HH:mm:ss"
                              );
                              return dataMoment.isValid();
                            })
                            .reduce((acc, lezione) => {
                              const dataMoment = moment(
                                lezione.data,
                                "YYYY-MM-DD HH:mm:ss"
                              );
                              const anno = dataMoment.format("YYYY");
                              const mese = dataMoment.format("MMMM");
                              const annoMese = `${anno}-${mese}`;

                              if (!acc[annoMese]) {
                                acc[annoMese] = { anno, mese, lezioni: [] };
                              }
                              acc[annoMese].lezioni.push(lezione);
                              return acc;
                            }, {})
                        );

                        // Traccia l'anno precedente per mostrarlo solo la prima volta
                        let annoPrecedente = null;

                        return gruppiMese.map(
                          ({ anno, mese, lezioni }, index) => {
                            // Dividi le lezioni in gruppi di 5
                            const lezioniOrdinate = lezioni.sort(
                              (a, b) => new Date(a.data) - new Date(b.data)
                            );
                            const righe = [];
                            for (
                              let i = 0;
                              i < lezioniOrdinate.length;
                              i += 5
                            ) {
                              righe.push(lezioniOrdinate.slice(i, i + 5));
                            }

                            const isPrimoAnno = anno !== annoPrecedente;
                            const annoCorrente = anno;
                            annoPrecedente = anno;

                            return righe.map((gruppoLezioni, rigaIndex) => (
                              <View
                                key={`${index}-${rigaIndex}`}
                                style={styles.tableRow}
                              >
                                {/* Colonna Anno */}
                                <View style={[styles.tableCell, { width: 45 }]}>
                                  <Text style={styles.cellText}>
                                    {rigaIndex === 0 && isPrimoAnno
                                      ? annoCorrente
                                      : ""}
                                  </Text>
                                </View>

                                {/* Colonna Mese */}
                                <View style={[styles.tableCell, { width: 75 }]}>
                                  <Text style={styles.cellText}>
                                    {rigaIndex === 0 ? mese : ""}
                                  </Text>
                                </View>

                                {/* 5 Colonne GG */}
                                {[0, 1, 2, 3, 4].map((colIndex) => {
                                  const lezione = gruppoLezioni[colIndex];
                                  if (!lezione) {
                                    return (
                                      <View
                                        key={colIndex}
                                        style={[
                                          styles.tableCell,
                                          { width: 89 },
                                        ]}
                                      >
                                        <Text style={styles.cellText}></Text>
                                      </View>
                                    );
                                  }

                                  const dataMoment = moment(
                                    lezione.data,
                                    "YYYY-MM-DD HH:mm:ss"
                                  );
                                  if (!dataMoment.isValid()) {
                                    console.log("Data invalida:", lezione.data);
                                    return (
                                      <View
                                        key={colIndex}
                                        style={[
                                          styles.tableCell,
                                          { width: 89 },
                                        ]}
                                      >
                                        <Text style={styles.cellText}>-</Text>
                                      </View>
                                    );
                                  }

                                  const giorno = dataMoment.format("DD");
                                  const giornoSettimana = dataMoment.format(
                                    "ddd"
                                  );
                                  const hasPagamento =
                                    lezione.pagamento ||
                                    lezione.pagamento_quota === "1" ||
                                    lezione.pagamento_quota === 1;

                                  return (
                                    <View
                                      key={colIndex}
                                      style={[styles.tableCell, { width: 89 }]}
                                    >
                                      <Text style={styles.cellText}>
                                        {giornoSettimana} {giorno}
                                      </Text>
                                      {hasPagamento && (
                                        <Text style={styles.pagQuotaText}>
                                          (pag.quota)
                                        </Text>
                                      )}
                                    </View>
                                  );
                                })}
                              </View>
                            ));
                          }
                        );
                      })()}
                  </View>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 15,
                    width: "100%",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      width: "85%",
                    }}
                  >
                    <Text style={styles.textFooter}>
                      L'ACCADEMIA RESTERA' CHIUSA PER LE VACANZE ESTIVE DALL'8
                      GIUGNO AL 5 SETTEMBRE 2025 E DAL 7 GIUGNO AL 4 SETTEMBRE
                      2026
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 15,
                    width: "100%",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "column",
                      width: "85%",
                    }}
                  >
                    <Text style={styles.text2Footer}>
                      ....................................................................
                    </Text>
                    <Text style={[styles.text2Footer, { marginTop: 5 }]}>
                      Firma per presa visione
                    </Text>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
        )}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 15,
  },
  tableWrapper: {
    width: "100%",
    marginTop: 8,
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#333",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#333",
    minHeight: 20,
  },
  tableCell: {
    borderRightWidth: 1,
    borderRightColor: "#333",
    padding: 4,
    justifyContent: "center",
  },
  headerCell: {
    backgroundColor: "#e0e0e0",
  },
  headerText: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
  },
  cellText: {
    fontSize: 8,
    textAlign: "center",
  },
  pagQuotaText: {
    fontSize: 6,
    textAlign: "center",
    color: "red",
    marginTop: 1,
  },
  giornoCell: {
    marginRight: 8,
    marginVertical: 2,
  },
  giornoText: {
    fontSize: 8,
  },
  textFooter: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
    lineHeight: 1.3,
  },
  text2Footer: {
    fontSize: 7,
    textAlign: "center",
  },
});
